// Header.js
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import MenuBars from "../../assets/imgs/menu-bars.svg";
import Menu from "./Menu";
import "./Header.css";
import Carrinho from "../carrinho/Carrinho";
import { useAuth } from "../../services/context/AuthContext";
import celllogo from '../../assets/imgs/logo (1).png';
import logo from "../../assets/imgs/logo.png";

import { CarrinhoContext } from '../../services/context/CarrinhoContext';
const Header = () => {

  const { totalItens } = useContext(CarrinhoContext);
  const main = process.env.REACT_APP_MAIN;
  const [isOpen, setIsOpen] = useState(false);
  const [isCarrinhoOpen, setCarrinhoIsOpen] = useState(false);
  const { user } = useAuth();
  console.log(user);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll behavior
    });
  };
  
  const toggleCarrinho = () => {

    document.body.classList.toggle('menu-open', !isCarrinhoOpen);
    setCarrinhoIsOpen(!isCarrinhoOpen);
    
  };


  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="header-wrapper">
      <div className="header-container">
        <Link to={main} onClick={scrollToTop}>
          <div className="logo">
            <div className="logo-link">
              <img src={logo} className="desk-logo" alt="logo imagem"></img>
              <img src={celllogo} alt="logo imagem" className="cell-logo"></img>
            </div>
          </div>
        </Link>

        <div className="header-links">
          <div className="header-desktop-menu">
            <Link onClick={scrollToTop} to={main}>Início</Link>
            <Link onClick={scrollToTop}  to={main + 'livros'}>Livros</Link>
            <Link onClick={scrollToTop}  to={main + 'contato'}>Contato</Link>
          </div>

          <div>
            
            <div className="perfil-header-link">
              {user ? (
                <Link to={main + "perfil"} alt="inicio" onClick={scrollToTop}>
                  <i class="uil uil-user"></i>
                </Link>
              ) : (
                <Link to={main + "login"} alt="inicio home" onClick={scrollToTop}>
                  <i class="uil uil-user"></i>
                </Link>
              )}
            </div>

            <button alt="toggle carrinho" className="cart-btn" onClick={toggleCarrinho}>
              <i class="uil uil-shopping-cart"></i>
              {(totalItens !== 0) && <span className="item-count">{totalItens}</span>}
            </button>

            <button alt="menu-toggle" className="menu-toggle" onClick={toggleSidebar}>
              <img src={MenuBars} alt="Menu Bars" />
            </button>
          </div>
        </div>
      </div>


      <Menu
        toggleSidebar={toggleSidebar}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      <Carrinho
        toggleSidebar={toggleCarrinho}
        isOpen={isCarrinhoOpen}
        setIsOpen={setCarrinhoIsOpen}
      />
    </div>
  );
};

export default Header;
